"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var Minus_1 = require("@styled-icons/entypo/Minus");
var Plus_1 = require("@styled-icons/entypo/Plus");
var styled_components_1 = __importStar(require("styled-components"));
function InputCounter(props) {
  var _this = this;
  var inputProps = props.inputProps,
    _onChange = props.onChange,
    value = props.value,
    callback = props.callback,
    _a = props.step,
    step = _a === void 0 ? 1 : _a;
  var preventBackspace = function preventBackspace(e) {
    return __awaiter(_this, void 0, void 0, function () {
      var min;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!(e.code === 'Backspace')) return [3 /*break*/, 2];
            if (!(value < (inputProps.min || 0))) return [3 /*break*/, 2];
            min = Number(inputProps.min) || 0;
            _onChange(min);
            if (!callback) return [3 /*break*/, 2];
            return [4 /*yield*/, callback(min)];
          case 1:
            _a.sent();
            _a.label = 2;
          case 2:
            return [2 /*return*/];
        }
      });
    });
  };

  var decrement = function decrement() {
    return __awaiter(_this, void 0, void 0, function () {
      var nextValue;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            nextValue = value - step;
            if (nextValue < (inputProps.min || 0)) {
              return [2 /*return*/];
            }

            _onChange(nextValue);
            if (!callback) return [3 /*break*/, 2];
            return [4 /*yield*/, callback(nextValue)];
          case 1:
            _a.sent();
            _a.label = 2;
          case 2:
            return [2 /*return*/];
        }
      });
    });
  };

  var increment = function increment() {
    return __awaiter(_this, void 0, void 0, function () {
      var nextValue;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            nextValue = value + step;
            _onChange(nextValue);
            if (!callback) return [3 /*break*/, 2];
            return [4 /*yield*/, callback(nextValue)];
          case 1:
            _a.sent();
            _a.label = 2;
          case 2:
            return [2 /*return*/];
        }
      });
    });
  };

  return react_1.default.createElement(StyledCounter, null, react_1.default.createElement("button", {
    disabled: inputProps.disabled,
    className: "minus-container",
    onClick: decrement
  }, react_1.default.createElement(Minus_1.Minus, {
    className: "minus"
  })), react_1.default.createElement("input", __assign({
    type: "number",
    onKeyUp: function onKeyUp(e) {
      preventBackspace(e);
    },
    onPaste: function onPaste(e) {
      return e.preventDefault();
    },
    onDrop: function onDrop(e) {
      return e.preventDefault();
    },
    value: value,
    onChange: function onChange(e) {
      var _value = e.target.value;
      _onChange(Number(_value));
    },
    onBlur: function onBlur() {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              if (!callback) return [3 /*break*/, 2];
              return [4 /*yield*/, callback(value)];
            case 1:
              _a.sent();
              _a.label = 2;
            case 2:
              return [2 /*return*/];
          }
        });
      });
    }
  }, inputProps)), react_1.default.createElement("button", {
    disabled: inputProps.disabled,
    className: "plus-container",
    onClick: increment
  }, react_1.default.createElement(Plus_1.Plus, {
    className: "plus"
  })));
}
var HideNativeCounter = styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &::-webkit-outer-spin-button,\n  &::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n  &[type='number'] {\n    -moz-appearance: textfield;\n  }\n"], ["\n  &::-webkit-outer-spin-button,\n  &::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n  &[type='number'] {\n    -moz-appearance: textfield;\n  }\n"])));
var StyledCounter = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  --border-style: solid 1px #dededf;\n  --border-style-hover: solid 1px #000000;\n  --button-bg-color: #f8f8f8;\n  --button-bg-color-hover: #ffffff;\n  --border-radius: 5px;\n  display: flex;\n  border: var(--border-style);\n  border-radius: var(--border-radius);\n  max-width: 100%;\n  & > input {\n    ", ";\n    outline: none;\n    border: var(--border-style);\n    text-align: center;\n    color: #666666;\n    font-weight: bold;\n    font-size: 14px;\n    width: 100%;\n    &:focus {\n      border: var(--border-style-hover);\n    }\n  }\n  & > .plus-container {\n    border-radius: 0 var(--border-radius) var(--border-radius) 0;\n  }\n  & > .minus-container {\n    border-radius: var(--border-radius) 0 0 var(--border-radius);\n  }\n  & > .plus-container,\n  .minus-container {\n    width: 40px;\n    height: 40px;\n    padding: 0 10px;\n    background-color: var(--button-bg-color);\n    border: var(--border-style);\n    &:disabled:hover {\n      background-color: var(--button-bg-color);\n      border: var(--border-style);\n    }\n    &:hover {\n      background-color: var(--button-bg-color-hover);\n      border: var(--border-style-hover);\n    }\n    & > .plus,\n    .minus {\n      width: 100%;\n      height: 100%;\n    }\n  }\n"], ["\n  --border-style: solid 1px #dededf;\n  --border-style-hover: solid 1px #000000;\n  --button-bg-color: #f8f8f8;\n  --button-bg-color-hover: #ffffff;\n  --border-radius: 5px;\n  display: flex;\n  border: var(--border-style);\n  border-radius: var(--border-radius);\n  max-width: 100%;\n  & > input {\n    ", ";\n    outline: none;\n    border: var(--border-style);\n    text-align: center;\n    color: #666666;\n    font-weight: bold;\n    font-size: 14px;\n    width: 100%;\n    &:focus {\n      border: var(--border-style-hover);\n    }\n  }\n  & > .plus-container {\n    border-radius: 0 var(--border-radius) var(--border-radius) 0;\n  }\n  & > .minus-container {\n    border-radius: var(--border-radius) 0 0 var(--border-radius);\n  }\n  & > .plus-container,\n  .minus-container {\n    width: 40px;\n    height: 40px;\n    padding: 0 10px;\n    background-color: var(--button-bg-color);\n    border: var(--border-style);\n    &:disabled:hover {\n      background-color: var(--button-bg-color);\n      border: var(--border-style);\n    }\n    &:hover {\n      background-color: var(--button-bg-color-hover);\n      border: var(--border-style-hover);\n    }\n    & > .plus,\n    .minus {\n      width: 100%;\n      height: 100%;\n    }\n  }\n"])), HideNativeCounter);
exports.default = InputCounter;
var templateObject_1, templateObject_2;